import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InviteLinkModel } from '../../../../api/models/invite-link-model';
import { InviteLinkService } from '../../../../api/services/invite-link.service';
import { AuthService } from '../../../../services/auth.service';
import { ToastService } from '../../../../services/toast.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-invite-link-details',
  templateUrl: './invite-link-details.component.html',
  standalone: false,
})
export class InviteLinkDetailsComponent {
  selectedExpiryDate: string | null = null;
  copiedToClipboard = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InviteLinkModel,
    private matDialogRef: MatDialogRef<InviteLinkDetailsComponent>,
    private inviteLinkService: InviteLinkService,
    private authService: AuthService,
    private toastService: ToastService,
    private datePipe: DatePipe,
  ) {
    this.selectedExpiryDate = this.datePipe.transform(
      data.expiresAt,
      'yyyy-MM-ddTHH:mm',
    );
  }

  close() {
    this.matDialogRef.close();
  }

  getInviteTypeLabel(): string {
    return this.data.publicInviteLink
      ? 'Public share invite'
      : 'Unique share invite';
  }

  getInviteDescription(): string {
    if (this.data.publicInviteLink) {
      return 'This public invite link can be copied and sent to multiple people. Anyone with the link can complete the questionnaire until it expires.';
    }

    return 'This unique invite link can be used to complete the questionnaire once. Generate separate unique links for multiple recipients.';
  }

  updateInviteLink() {
    this.inviteLinkService
      .inviteLinksPut(
        { body: { guid: this.data.guid, expiresAt: this.selectedExpiryDate } },
        this.authService.getAuthorisationHeaders(),
      )
      .subscribe({
        next: (updatedLink) => {
          this.matDialogRef.close(updatedLink);
          this.toastService.success('Successfully Updated Invite Link');
        },
        error: () => {
          this.matDialogRef.close();
          this.toastService.error('Could Not Update Invite Link');
        },
      });
  }
}
